const PROJECT_CDN = {
  Wardroll:
    "https://res.cloudinary.com/dywhcxdix/video/upload/f_auto:video,q_auto/v1/Portfolio_assets/isgw3pulsrrcs2cspgfv",
  GitPulse:
    "https://res.cloudinary.com/dywhcxdix/video/upload/f_auto:video,q_auto/v1/Portfolio_assets/abuvd8d8bjdd9gaigkxu",
  npmPackage:
    "https://res.cloudinary.com/dywhcxdix/video/upload/f_auto:video,q_auto/v1/Portfolio_assets/y1vri0bl8uhcltoin9oi",
  CryptoBazar:
    "https://res.cloudinary.com/dywhcxdix/video/upload/f_auto:video,q_auto/v1/Portfolio_assets/mnvdlpc2953jxh9k48zr",
};

export const projectsContent = {
  eyebrow: "Selected work",
  title: "Projects",
  subtitle: "Check out some of my work right here",
};

export const projects = [
  {
    id: "wardroll",
    name: "Saas Product @Wardroll",
    tagline: "B2B SaaS · Fashion creator platform",
    video: PROJECT_CDN.Wardroll,
    tech: [
      "Next.js",
      "TypeScript",
      "Material UI",
      "Tailwind CSS",
      "Sentry",
      "Google Analytics",
    ],
    description: [
      "Spearheaded UI development with Next.js, TypeScript, Material UI, and Tailwind CSS to create a state-of-the-art interface.",
      "Guaranteed scalability and seamless Meta API integration, maintaining top-tier code standards for peak performance.",
      "Pioneered frontend development from the ground up through close collaboration with the CTO.",
    ],
  },
  {
    id: "git-pulse",
    name: "Git Pulse",
    tagline: "GitHub analytics · Personalised dev insights",
    video: PROJECT_CDN.GitPulse,
    tech: ["React.js", "Tailwind CSS", "GitHub REST APIs", "Chart.js", "Axios"],
    description: [
      "Built a sleek web app with GitHub REST APIs, giving users a unique, personalised view of their GitHub data.",
      "Created visuals for followers, repos, languages, and forks using Chart.js and modern UI patterns.",
      "Achieved seamless, fast access to complex GitHub data with a clean, responsive interface.",
    ],
    liveURL: "https://gitpulse.anshjatana.online",
    githubURL: "https://github.com/Anshjatana/Git-Pulse",
  },
  {
    id: "format-your-date",
    name: "Format your Date",
    tagline: "Open-source · NPM package",
    video: PROJECT_CDN.npmPackage,
    tech: ["TypeScript", "Node.js"],
    description: [
      "Published format-your-date to NPM — 500+ downloads in the first week.",
      "Built with TypeScript for type safety and compatibility across modern JavaScript environments.",
      "Lightweight, customisable date formatting with zero performance overhead.",
    ],
    liveURL: "https://www.npmjs.com/package/format-your-date",
    githubURL: "https://github.com/Anshjatana/format-your-date",
  },
  {
    id: "cryptobazar",
    name: "CryptoBazar",
    tagline: "Real-time crypto · WebSocket powered",
    video: PROJECT_CDN.CryptoBazar,
    tech: [
      "React.js",
      "Tailwind CSS",
      "CoinGecko APIs",
      "Express.js",
      "WebSocket",
    ],
    description: [
      "Dynamic homepage with 10 cryptocurrencies powered by WebSocket for real-time market data.",
      "Dedicated coin pages with detailed market insights for informed investment decisions.",
      "Customisable light and dark themes for accessibility and personalisation.",
    ],
    liveURL: "https://cryptobazar.anshjatana.online",
    githubURL: "https://github.com/Anshjatana/CryptoBazar",
  },
];
